import React from 'react';
import { Helmet } from 'react-helmet';

import { isBuildTime } from '@powdr/utils';

export const Fareharbor = () => {
  if (isBuildTime()) return null;

  return (
    <Helmet>
      <script type="text/javascript" src="https://fareharbor.com/embeds/api/v1/?autolightframe=yes" target="_blank" />
    </Helmet>
  );
};

Fareharbor.propTypes = {};
